import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "entry", "template"];

  connect() {
    // Initialize the controller
    this.updateIndices();
  }

  add(event) {
    event.preventDefault();

    // Clone the template
    const template = this.templateTarget.content.cloneNode(true);

    // Add the new entry to the container
    this.containerTarget.appendChild(template);

    // Update the indices of all entries
    this.updateIndices();
  }

  remove(event) {
    event.preventDefault();

    // Find the entry to remove
    const entry = event.target.closest(
      "[data-athletes--video-entries-target='entry']"
    );

    // Remove the entry
    entry.remove();

    // Update the indices of all entries
    this.updateIndices();
  }

  updateIndices() {
    // Get all entries
    const entries = this.entryTargets;

    // Update the indices of all entries
    entries.forEach((entry, index) => {
      // Update the title input
      const titleInput = entry.querySelector("input[name*='[title]']");
      if (titleInput) {
        titleInput.name = `athlete[other_videos][${index}][title]`;
      }

      // Update the URL input
      const urlInput = entry.querySelector("input[name*='[url]']");
      if (urlInput) {
        urlInput.name = `athlete[other_videos][${index}][url]`;
      }
    });
  }
}
